import { getApiBase } from "_helpers";
import { cookieService } from "_services";

const getFileAccessLog = async (filters) => {
  const apiBase = getApiBase();

  const params = new URLSearchParams();
  Object.entries(filters || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") params.append(k, v);
  });
  if (process.env.NODE_ENV !== "production") {
    params.append("jwtCookie", cookieService.get("token"));
  }

  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  const response = await fetch(`${apiBase}/claim/getfileaccesslog?${params.toString()}`, requestOptions);

  if (response.status === 403) {
    throw new Error("Invalid Auth Token");
  }
  if (!response.ok) {
    throw new Error("Failed to fetch file access log");
  }
  return await response.json();
};

export const fileAccessLogService = {
  getFileAccessLog,
};
